const CONFIG_STORAGE_KEY = "equip_active_config";

export interface EquipConfig {
  CLIENT_ID: string;
  REDIRECT_URI: string;
  SCOPE: string;
  BASE_URL: string;
  TAG: string;
}

export const localConfig: EquipConfig = {
  TAG: "LOCAL",
  BASE_URL: "https://equip-research.trading-equities.dev.jarden.work",
  CLIENT_ID: "d85669a7-e516-4097-9b5a-b0d739447813",
  REDIRECT_URI: "https://localhost:3000/redirect",
  SCOPE: "api://equip-research-dev/equip-research-user",
};

export const devConfig: EquipConfig = {
  TAG: "DEV",
  BASE_URL: "https://equip-research.trading-equities.dev.jarden.work",
  CLIENT_ID: "d85669a7-e516-4097-9b5a-b0d739447813",
  REDIRECT_URI: "https://equip-excel.trading-equities.dev.jarden.work/redirect",
  SCOPE: "api://equip-research-dev/equip-research-user",
};

export const prdConfig: EquipConfig = {
  TAG: "PRD",
  BASE_URL: "https://equip-research.trading-equities.jarden.work",
  CLIENT_ID: "2ff58acb-26cd-4e87-88aa-7c2c677083b0",
  REDIRECT_URI: "https://equip-excel.trading-equities.jarden.work/redirect",
  SCOPE: "api://equip-research-prd/equip-research-user",
};

export function loadConfigFromStorage(): EquipConfig | null {
  if (typeof window === "undefined") return null; // SSR/Office edge cases

  try {
    const raw = window.localStorage.getItem(CONFIG_STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as EquipConfig;
  } catch (err) {
    console.warn("Failed to parse stored config", err);
    return null;
  }
}

export function saveConfigToStorage(config: EquipConfig) {
  if (typeof window === "undefined") return;

  try {
    window.localStorage.setItem(CONFIG_STORAGE_KEY, JSON.stringify(config));
  } catch (err) {
    console.warn("Failed to persist config", err);
  }
}
